export enum EmailFormFields {
  FROM_EMAIL = 'fromEmail',
  TO_EMAIL = 'toEmail',
  SUBJECT = 'subject',
  MESSAGE = 'message',
}
